<div class="height100p flex-col-fixed-fill">
    <sm-toolbar>
        <p-button [disabled]="!isChanged()" icon="fas fa-save" label="Speichern" (onClick)="save()">
        </p-button>
    </sm-toolbar>
    <sm-table [data]="table"></sm-table>
</div>